import type { StateCreator } from 'zustand';

// ADR 0396: Modus der Arbeitsliste („Anrufen“ oder „LinkedIn“) und das gewählte LinkedIn-Konto. Der Modus bleibt
// im Browser, damit die Seite im zuletzt benutzten Modus startet (Frage 14). Das Schild am Konto liegt auf dem
// Server (`konto_schild`); dieser Zustand merkt nur, welches Konto DIESER Tab gerade hält.
export type ArbeitslisteModus = 'anrufen' | 'linkedin';
const MODUS_KEY = 'arbeitsliste_modus';

function gespeicherterModus(): ArbeitslisteModus {
  try { return localStorage.getItem(MODUS_KEY) === 'linkedin' ? 'linkedin' : 'anrufen'; } catch { return 'anrufen'; }
}

export interface LinkedinArbeitSlice {
  arbeitslisteModus: ArbeitslisteModus;
  linkedinKontoId: number | null;
  setzeArbeitslisteModus: (m: ArbeitslisteModus) => void;
  setzeLinkedinKonto: (id: number | null) => void;
}

export const createLinkedinArbeitSlice: StateCreator<LinkedinArbeitSlice> = (set) => ({
  arbeitslisteModus: gespeicherterModus(),
  linkedinKontoId: null,
  setzeArbeitslisteModus: (m) => {
    try { localStorage.setItem(MODUS_KEY, m); } catch { /* ohne Speicher startet die Seite eben im Anruf-Modus */ }
    set(m === 'anrufen' ? { arbeitslisteModus: m, linkedinKontoId: null } : { arbeitslisteModus: m });
  },
  setzeLinkedinKonto: (id) => set({ linkedinKontoId: id }),
});
